// Shared "proven" email templates used by both the Campaigns composer and the
// per-lead follow-up sender in the Pipeline drawer.
export const EMAIL_TEMPLATES = [
  {
    id: "ask-review", name: "Ask for Review",
    subject: "How did we do? Your feedback helps EWS",
    message: "Hi there,\n\nThank you for choosing EWS for your waste and recycling service. We are grateful to have you as a customer.\n\nIf our team has made service easier for your business, would you take 30 seconds to leave us an honest Google review? Your feedback helps other Miami-Dade businesses find a local hauler they can count on.\n\nClick the button below to leave your review. Thank you for your business and support.\n\n— The EWS Team",
    design: "review",
  },
  {
    id: "reengage", name: "Long time, no hear (re-engage)",
    subject: "It's been a while — let's talk trash",
    message: "Hi there,\n\nIt's been a minute since we last connected! Your Miami-Dade business deserves waste service that's affordable, reliable, and completely hassle-free.\n\nWe're still ready to beat or match your current hauler's price — and switching takes just a few days.\n\nReply to this email or call (305) 691-1516 and we'll take it from here.\n\n— The EWS Team",
  },
  {
    id: "followup", name: "Proposal nudge (savings waiting)",
    subject: "Your savings are still on the table",
    message: "Hi there,\n\nWe recently put together a proposal to help lower your waste costs — and we'd hate for those savings to slip away.\n\nSwitching is effortless: we handle the swap, the schedule, and all the paperwork.\n\nReady to lock in your rate? Just reply or call (305) 691-1516.\n\n— The EWS Team",
  },
  {
    id: "pricebeat", name: "Price-beat guarantee",
    subject: "Paying too much for waste pickup?",
    message: "Hi there,\n\nMost Miami-Dade businesses are overpaying for trash service — and don't even realize it.\n\nSend us a photo of your current invoice and we'll beat or match it, guaranteed. No pressure, no obligation.\n\nReply with your bill or call (305) 691-1516.\n\n— The EWS Team",
  },
  {
    id: "seasonal", name: "Seasonal / cleanup promo",
    subject: "Big project coming up? We've got the dumpster",
    message: "Hi there,\n\nTackling a cleanup, renovation, or construction job? EWS has roll-off dumpsters in every size — 10 to 40 yards — delivered across Miami-Dade.\n\nBook this month and save. Call (305) 691-1516 or reply to reserve yours today.\n\n— The EWS Team",
  },
  {
    id: "recycling", name: "New service: recycling",
    subject: "New: recycling that actually cuts your bill",
    message: "Hi there,\n\nEWS now offers cardboard, single-stream, and organics recycling that can lower your monthly disposal costs while keeping your business compliant.\n\nWant to see how much you could save? Reply or call (305) 691-1516.\n\n— The EWS Team",
  },
];
